import React from 'react';
import { ValidationErrors } from 'constants/validations';
import { TransferComponent } from 'components/common/transferComponent';
import { Button, Col, Divider, Form, Input, Row, Typography } from 'components';
import styles from './../styles.module.scss';
import { useAddEdit } from './useAddEdit';

const { Item } = Form;
const { TextArea } = Input;

export const AddEditRole = () => {
  const {
    form,
    roleDetails,
    isLoading,
    disableSaveBtn,
    onFinish,
    onCancel,
    targetKeys,
    onChange,
    onSearch,
    handlePageChange,
    isPermissionLoading,
    permissionData,
    onValuesChange,
    contextHolder,
  } = useAddEdit();

  return (
    <>
      {contextHolder}
      <Row justify={'end'} gutter={[0, 32]}>
        <Col span={24}>
          <Row gutter={[0, 24]} justify={'center'}>
            <Col span={24}>
              <Typography.Title className={styles.add_edit_title} level={2}>
                {roleDetails ? 'Update' : 'Add'} Role
              </Typography.Title>
            </Col>
            <Col span={24} className={styles.form_container}>
              <Form
                onValuesChange={onValuesChange}
                onFinish={onFinish}
                requiredMark={false}
                layout={'vertical'}
                form={form}
              >
                <Row gutter={[0, 16]}>
                  <Col span={12}>
                    <Item
                      label={'Role Name*'}
                      name={'name'}
                      rules={[{ required: true, message: ValidationErrors.required('Role Name') }]}
                    >
                      <Input size={'large'} />
                    </Item>
                  </Col>
                  <Col span={24}>
                    <Item name="description" label={'Role Description'}>
                      <TextArea style={{ resize: 'none', height: 100 }} size={'large'} />
                    </Item>
                  </Col>
                  <Col span={24}>
                    <Item label="Permissions*">
                      <Typography.Text type={'secondary'} style={{ marginBottom: 12, display: 'inline-block' }}>
                        To assign permissions, select from the left list and move them to the right panel.
                      </Typography.Text>
                      <Item
                        name="permissions"
                        rules={[{ required: true, message: ValidationErrors.required('Permissions') }]}
                      >
                        <TransferComponent
                          data={permissionData}
                          initialData={roleDetails?.permissions}
                          targetKeys={targetKeys}
                          onChange={onChange}
                          onSearch={onSearch}
                          isLoading={isPermissionLoading}
                          handlePageChange={handlePageChange}
                          titles={{ left: 'All Permissions', right: 'Assigned Permissions' }}
                        />
                      </Item>
                    </Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
        <Divider className={styles.divider} />
        <Col flex={'328px'}>
          <Row wrap={false} className="gap-8">
            <Button block size="large" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              block
              size="large"
              disabled={disableSaveBtn}
              type="primary"
              loading={isLoading}
              onClick={() => {
                form?.submit();
              }}
            >
              {roleDetails ? 'Save' : 'Add'}
            </Button>
          </Row>
        </Col>
      </Row>
    </>
  );
};
